module.exports = __webpack_public_path__ + "static/image/history/pc/202210@3x.ver2_0_2.jpg?7473f219";